/**
 * Provides a simple method for hiding an element when the
 * app is running in the native SonderMind app.
 *
 * **Usage:**
 *
 * *nativeAppHidden or *nativeAppHidden="true" will remove
 * the element from the DOM.
 */

import {
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';

import { NativeAppContextHelpers } from '../services/native-app-context.helpers';

@Directive({
  selector: '[nativeAppHidden]'
})
export class NativeAppHiddenDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    const isHostedInNativeApp = NativeAppContextHelpers.isHostedInNativeApp();

    if (isHostedInNativeApp) {
      this.viewContainer.clear();
    } else {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
